import React from 'react';

const Policy = () => {
  return (
    <div style={{ padding: '30px' }}>
      <h1>PRIVACY POLICY</h1>

      <p>
        The privacy policy (“Privacy Policy”) governs the use of the mobile
        application and/or website “Humbee” (“Website”, “we”, “us”) and the
        services (“Services”) being provided on the Website by Twenty Point Nine
        Five Ventures Private Limited (“Company” or “We”). This Privacy Policy
        has been duly framed in accordance with the Information Technology Act,
        2000 (“Act”) and the rules made thereunder to ensure maximum protection
        to the information provided by its users (“you”).
      </p>
      <p>
        This Privacy Policy is applicable to any person (‘User’) who access,
        uses or inquire about any product(s) or service(s) made available by us
        on Humbee.
      </p>
      <p>
        We recognize the importance our customers place on the privacy and
        security of their business and personal information. Our goal is to
        protect your information in every way that We interact with You, whether
        on the Internet or otherwise.
      </p>
      <p>
        With this objective in mind, we have formulated this Privacy Policy to
        help you to understand the steps we take to protect your personal
        information when you utilize our online services.
      </p>
      <p>
        By using the Website, you agree to abide by the terms and conditions
        pertaining to collection, retention and use of information set forth in
        this Privacy Policy. If you do not agree to the Privacy Policy, you may
        cease to use the Website.
      </p>
      <p>
        In addition to the considerations stipulated under this Privacy Policy,
        your access and activities on the Website shall also be governed by the
        Agreements signed by the respective parties with Twenty Point Nine five
        Ventures Private Limited (“Company”) and any other terms and conditions
        as published by the Company on the website from time to time.
      </p>

      <p>
        This Privacy Policy does not apply to any website(s), mobile sites and
        mobile apps of third parties, even if their websites/products are linked
        to Website. User are advised to take note that information and privacy
        practices of third-party application, may be materially different from
        this Privacy Policy. Accordingly, it is recommended that you review the
        privacy statements and policies of any such third parties with whom they
        interact.
      </p>
      <p>
        This Privacy Policy is incorporated in the Terms of Use of the Website
        and any other agreement, in which there is a specific clause
        incorporating the Privacy Policy in such agreement. In the event of any
        contradiction, term of such agreement shall prevail.
      </p>
      <ul>
        <li>
          Our role in protection of User Information: Mode of information
          Collection
        </li>
        <li>
          We are committed to protecting the privacy of the information being
          provided by you on the Website.
        </li>
        <li>
          We may collect personally identifiable information about a customer or
          former customer of the Website (“Customer Information”).
        </li>
        <li>
          We may collect, retain and process the information provided by you
          through e-mail or filing of forms on the Website including but not
          limited to Information such as your name, address, phone number, other
          contact details, marital status, email id, details of the organisation
          on behalf of whom you are acting (if applicable) and other information
          such as bank account or credit card or debit card or other payment
          instruments, income details, any other supporting of foregoing
          (“Personal Information”).
        </li>
        <li>
          Further, we collect, store and process such other information
          including but not limited to information about your Transaction
          undertaken on the Website, communication made by you for customer
          service, to provide updates about the Transaction undertaken on
          website, information generated electronically when you visit the
          Website or contact you on birthday or anniversary, use our services
          and any modifications made to the information provided by you (“Other
          Information”).
        </li>
        <li>
          To access our Service effectively Humbee may request for access of
          location on user’s phone, image, videography functionality or such
          other user data as deemed relevant by the Humbee. Humbee shall protect
          and use such information for providing its service to user. User shall
          have an option to withdraw its consent any time by intimating to us.
        </li>
        <li>
          We value opinions and comments from our Users and frequently conduct
          surveys, both online and offline. Participation in these surveys is
          entirely optional. Typically, the information received is aggregated,
          and used to make improvements to Website, services and to develop
          appealing content, features and promotions for members based on the
          results of the surveys. Identity of the survey participants may be
          anonymous unless otherwise stated in the survey.
        </li>
        <li>
          Marketing promotions, research and programs help us to identify your
          preferences, develop programs and improve user experience. Humbee
          frequently sponsors promotions to give its Users the opportunity to
          win great travel and travel related prizes. Personal Information
          collected by us for such activities may include contact information
          and survey questions. We use such Personal Information to notify
          contest winners and survey information to develop promotions and
          product improvements. Phone number collected shall be utilized to
          enable you to access our various functionality of Service.
        </li>
        <li>
          In addition, you may also be receiving periodic marketing emails,
          newsletters and exclusive promotions offering special deals.
        </li>
        <li>
          From time to time we may add or enhance services available on the
          Website. To the extent these services are provided, and used by you,
          we will use the Personal Information, you provide to facilitate the
          service(s) requested. For example, if you email us with a question, we
          will use your email address, name, nature of the question, etc. to
          respond to your question. We may also store such Personal Information
          to assist us in making the Website the better and easier to use for
          our Users.
        </li>
        <li>
          Humbee may launch reward programs by way of which users may stand to
          win travel related rewards or many other rewards. We may use your
          Personal Information to enroll you in the rewards program and status
          of the same will be visible each time you log in to the Website.
          Depending on the reward program, each time you win a reward, Humbee
          may share your Personal Information with a third party that will be
          responsible for fulfilling the reward to you. You may however choose
          to opt out of such reward programs by writing to us. For various
          purposes such as fraud detection, offering bookings on credit etc., we
          at times may verify information of customers on selective basis,
          including their credit information. Additionally, Humbee may share
          your Personal Information, anonymized and/ or aggregated data to a
          third party that we may engage to perform certain tasks on its behalf,
          including but not limited to payment processing, date verification,
          data hosting, data processing and assessing credit worthiness.
        </li>
        <li>
          We or Service Providers (third parties who provide range of services
          like website hosting, digital signature verification, etc.) and the
          Website may collect general information on our Website visitors for
          security and statistical purposes. Such information may include but
          not limited to certain automatically generated information including
          your IP address, internet address of the referral site which brought
          you to visit our Website, date and time of visiting the Website, the
          name and version of your web browser, online activity, and duration of
          your online session. We and/ or third party service providers engaged
          by us may monitor and collect such information that will enable us to
          verify your credentials, maintain reasonable security practices,
          enable inclusion of better Services, fulfil your requests and enhance
          your user experience. Further, we and/ or our Service Providers may
          also collect “Cookies” (piece of software code that the Website
          automatically sends to your browser when you access the Website) in
          order to collect some of the above mentioned information that enable
          us to provide you a better user experience. In some case, you must
          accept the Cookies in order to view our Website. Advertisements may be
          displayed on our Website as well as on third party websites. When you
          click such advertisements you may receive another Cookie, which you
          may or may not choose to accept. The use of cookies by them is subject
          to the privacy policy and other terms and conditions governing their
          website.
        </li>
      </ul>
      <h3>Usage of Collected Information</h3>

      <ul>
        <li>
          The User Information provided by you may be used by us and provided to
          third party websites, affiliates, consultants, employees in order to
          manage, collect, store, process the User Information in order to
          improve the quality, design, functionality and content of the Website
          and to any governmental authority under applicable law.
        </li>
        <li>
          The User Information provided by you shall be used to communicate with
          you by us through newsletters, SMS, whatsup messages, updates,
          notifications and other forms of communication.
        </li>
        <li>
          The User Information shall be used for purposes only in relation to
          the Website and not for any other purposes and upto such period as may
          be considered necessary by us for the purpose of operating the
          Website.
        </li>
        <li>
          You shall have the right to view the information provided by you and
          also to update the information and keep us informed of any such change
          in case the information provided is deficient or inaccurate.
        </li>
        <li>
          We will retain your Personal Information on our servers for as long as
          is reasonably necessary for the purposes listed in this policy. In
          some circumstances we may retain your Personal Information for longer
          periods of time, for instance where we are required to do so in
          accordance with any legal, regulatory, tax or accounting requirements.
        </li>
        <li>
          You undertake that the Personal Information and Other Information
          provided by you is true and accurate to the best of your knowledge.
          You agree and understand that we shall not be liable for the
          authenticity of the Personal Information and Other Information
          provided by you.
        </li>
        <li>
          You shall provide us with all the information requested from you on
          the Website or through any other mode of communication. You are not
          legally obligated to provide us with all the information. However,
          complete functionality of the Website shall not be rendered possible
          if you fail to provide us with certain necessary information for the
          purpose of the Services of the Website. Without prejudice to the
          aforesaid, you shall have an option to, while availing the Services,
          to withdraw your consent to allow us to use the Personal Information
          provided by you and intimate us of the same in writing.
        </li>
      </ul>
      <h3>Disclosure of User Information</h3>
      <ul>
        <li>
          Any Personal Information provided by you shall be made available to
          our Service Providers, third parties, employees, that are connected
          with or in relation to the Services of the Website. Such user shall
          not disclose the User Information disclosed to it further other than
          under such circumstances where disclosure is permissible by us under
          the terms and conditions of the Privacy policy.
        </li>
        <li>
          Other than as set out above, we shall not disclose the User
          Information to any third party without your consent, provided that
          such information may be disclosed to governmental agencies or bodies
          as required under applicable law or to exercise legal rights or defend
          legal claims or protect the safety of other users or public or our
          rights.
        </li>
      </ul>

      <h3>Links to third party websites</h3>
      <p>
        The Website contains links to third party websites. We are not
        responsible for any content on such third party websites and we shall
        not be liable for any breach of privacy policy by such websites. You
        undertake to read and understand the privacy policy of such third party
        websites. For the avoidance of doubt, our Privacy Policy only governs
        the User Information collected, received, possessed, stored, dealt with
        or handled for the purposes of Services on our Website.
      </p>
      <h3>Updates sent by the Website</h3>
      <p>
        We may send an email communication to individuals once they sign up to
        avail services. We will send security related e-mail notifications once
        you sign up for “notify me” updates on your account(s). Further, we may
        send e-mail notifications whenever you change your passcode, security
        question or designated e-mail address.
      </p>

      <h3>Security Practices</h3>

      <p>
        The User Information shall be governed by and protected by us according
        to the security practices and procedures mandated under the Act and more
        particularly described under the Information Technology (Reasonable
        Security Practices & Procedures and Sensitive Personal Data or
        Information) Rules, 2011 and Information Technology (Intermediary
        Guidelines) Rules, 2011.
      </p>

      <h3>Modification of the Privacy Policy</h3>
      <p>
        The Privacy Policy may be modified, or updated from time to time at our
        sole discretion and the updated Privacy Policy shall be published on the
        Website and no separate communication shall be made in respect of the
        same. It shall be user responsibility to keep itself aware with changes
        to the Privacy Policy by regularly checking the Website for updates.
        Access and continued usage of the Website’s after change to Privacy
        Policy shall be considered as acceptance of the changed Privacy Policy
        on your behalf.
      </p>

      <h3>Disclaimer of liability for User Information Security</h3>
      <ul>
        <li>
          Notwithstanding the aforesaid, despite our efforts to maintain privacy
          and confidentiality of the User Information, we may not be able to
          protect or prevent the unauthorised access or use, software failure or
          fault, or other factors that may compromise the security of the User
          Information.
        </li>
        <li>
          You agree and understand that Internet is not a secure source and
          therefore, we cannot guarantee the protection of such User
          Information.
        </li>
        <li>
          For the avoidance of doubt, if any User Information is compromised
          despite our efforts to prevent the occurrence of the same, you shall
          not hold us liable for such breach of privacy protection under the
          Privacy Policy of the Website.
        </li>
      </ul>
      <h3>PERMISSIONS REQUIRED FOR USING OUR MOBILE APPLICATION</h3>
      <p>
        When the Humbee app is installed on your phone or tablet, a list of
        permissions appears and are needed for the app to function effectively.
        There may not be an option to customize the list. Once you approve to
        access of such function, Humbee shall collect the necessary information
        to perform the Transaction and Services.
      </p>

      <h3>Grievance Redressal Mechanism</h3>

      <ul>
        <li>
          In order to address any of your grievances or discrepancies of
          information displayed on the Website, the Website shall designate a
          grievance redressal officer (“Grievance Officer”).
        </li>
        <li>
          The Grievance Officer shall redress all the grievances expeditiously
          as provided under the Act.
        </li>
        <li>Contact detail of Grievance Officer:</li>
      </ul>
      <p>Mr. Janardhan Shamra</p>
      <p>Grievance Office</p>
      <p>619, Tower B, Noida One, Sector 62, </p>
      <p>Noida (U.P.) India – 201309</p>
      <p>Email:care@20p95.com </p>
      <p>Phone: +9199902 02200</p>
    </div>
  );
};
export default Policy;
